import React, { Component } from 'react';
import {Form,Select,Input,Icon,Button,message} from 'antd';
import {pepoleWip,newUser,editUser,mailFinder,editUsername} from '../../stores/APIEndpoints';
import {booleanAsString, toUrlParams} from "../../stores/Util";
import DynamicForm from "../DynamicForm";
import looseLeafStore from "../../stores/LooseLeafStore";
import {appStore} from '../../stores/AppStore';
import {inject, observer} from 'mobx-react';
import DashboardStore from '../../stores/DashboardStore';
const { Option } = Select;
import '../../../src/index.css';
import moment from 'moment';



class EditUser extends Component {
  
    constructor(props) {
        super(props);
        this.apiProxy = appStore.apiProxy;
        this.state = {
          name: " ",
          email: " "
        }
    }

    handleSubmit = e => {
      e.preventDefault();
      this.props.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
        
          const bodyParams = {
            "name" :  this.state.name,
            "email" : values.UserEmail[0],
          }
          this.userRegister(bodyParams);
        }
      });
    };
   userRegister= async(bodyParams) =>{
    let response = await this.apiProxy.asyncPost(editUser, bodyParams);
    const option = await response.json();
  
   if(option.messages == "User Name updated Successfully")
    {
      message.success('User Name updated Successfully');
    }
    else if(option.message == "Provide valid data")
      {
        message.error('Provide valid data');
      }
   }
   handleInputChange(e) {
    this.setState({
      name: e.target.value
    });
   }
 
  handleChange=(value)=> {
    this.setState({children:[]});
   
  }
  validationText= async(value)=>{
    
    if(value.match(/@/g))
    {
      const params = {
        email:value
     };
      const url = mailFinder + '?' + toUrlParams(params);
      const response = await this.apiProxy.getAsync(url);
      const data = await response.json();
      this.setState({email:data[0].name});
      const childrenData = [];
      if(data.length != 0)
      {
        for (let i = 0; i < data.length; i++) {
          childrenData.push(<Option key={data[i].name}>{data[i].name}</Option>);
        }
      }
      else
      {
        message.error('Please register new user.');
      }
       
       this.setState({children:childrenData});
     
      
    }
    else
    {
    //	alert("false");
    }
  }
  clearChildred=()=>{
    this.setState({children:[]});
  }
  fetchuser= async()=>{
      const bodyparams = {
        email : this.state.email
     };
     const url = editUsername + '?' + toUrlParams(bodyparams);
      const response = await this.apiProxy.getAsync(url);
      const data = await response.json();
      this.setState({name:data.user_name});
      if(data.message == "Provide valid data")
      {
        message.error('Provide user E-mail!');
      }
  }
  render() {
   
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
    };
   
        return (
          <Form name="normal_login" className="login-form"  {...formItemLayout}>
          <Form.Item label="User Email"  name="UserEmail" >
              {getFieldDecorator('UserEmail', {
                  rules: [{ required: true, message: 'Please input your E-mail!' }]
                  })(
                    <Select
                      mode="multiple"
                      style={{ width: '100%' }}
                      //placeholder="Useremail"
                      onSearch={this.validationText}
                      onChange={this.handleChange}
                      
                    >
                      {this.state.children}
                    </Select>,
                    )}
                     <Button type="primary" htmlType="submit" onClick={this.fetchuser} className="login-form-button">
                       Fetch User Name
                      </Button> 
                      
              </Form.Item>
              <br></br>
          <Form.Item label="User Name">
              <Input 
                  //prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  placeholder="Username"  
                  value={this.state.name}
                  //onChangevalue={(text)=>this.setState({name:text})}
                  onChange={e => this.handleInputChange(e)}
                  />
               <Button type="primary" htmlType="submit" onClick={this.handleSubmit} className="login-form-button">
                  Update
              </Button>
          </Form.Item>
          </Form>
        );
      }
     
   
  }


export default Form.create({ name: 'normal_login' })(EditUser);

// export default WrappedNormalLoginForm;

